import { CurrentStepEnum } from "@boundless/bl-api-client/customer/models"
import { linkOptions, type NavigateOptions } from "@tanstack/react-router"

import type { BoundlessRouter } from "@/main"

import type { CountryEnum } from "@boundless/bl-api-client/customer/models"

export const CSRF_COOKIE_NAME = "csrftoken"

// Matches the `request_login_code` backend throttle (ACCOUNT_RATE_LIMITS in
// apps/boundless/settings/main.py): one code request per email per window.
export const RESEND_SECONDS = 90

export const SESSION_TOKEN_STORAGE_KEY = "session_token"

export const enum Client {
  APP = "app",
  BROWSER = "browser",
}

export const SSN_REQUIRED_CITIZENSHIP = ["US", "CA", "GB", "AU"]

export const ssnFieldCountryLabels: Record<keyof typeof CountryEnum, string> = {
  US: "Social Security Number (SSN)",
  CA: "Social Insurance Number (SIN)",
  GB: "National Insurance Number (NIN)",
  AU: "Tax File Number (TFN)",
}

export const OwnerIndex = {
  FIRST: 1,
  SECOND: 2,
}

export const StepPaths: Record<
  CurrentStepEnum,
  (uuids: {
    applicationUuid: string
    fundingNeedsUuid: string
  }) => NavigateOptions<BoundlessRouter>
> = {
  [CurrentStepEnum.submit]: ({ applicationUuid }) =>
    linkOptions({
      to: "/applications/$applicationUuid/submit",
      params: { applicationUuid },
    }),
  [CurrentStepEnum.documents]: ({ applicationUuid }) =>
    linkOptions({
      to: "/applications/$applicationUuid/upload-documents",
      params: { applicationUuid },
    }),
  [CurrentStepEnum.sign]: ({ applicationUuid }) =>
    linkOptions({
      to: "/applications/$applicationUuid/sign",
      params: { applicationUuid },
    }),
  [CurrentStepEnum.lender]: ({ fundingNeedsUuid }) =>
    linkOptions({
      to: "/funding-requests/$fundingNeedsUuid/lender-match",
      params: { fundingNeedsUuid },
    }),
  [CurrentStepEnum.funding]: () =>
    linkOptions({ to: "/funding-requests/create" }),
  [CurrentStepEnum.articles]: () =>
    linkOptions({
      to: "/company/articles-of-incorporation",
    }),
  [CurrentStepEnum.debt]: () =>
    linkOptions({
      to: "/company/debt-table",
    }),
  [CurrentStepEnum.plaid]: () => linkOptions({ to: "/company/plaid" }),
  [CurrentStepEnum.ownership]: () =>
    linkOptions({
      to: "/company/ownership-details",
      search: { step: "primary" },
    }),
  [CurrentStepEnum.details]: () => linkOptions({ to: "/company/details" }),
  [CurrentStepEnum.address]: () => linkOptions({ to: "/company/address" }),
  [CurrentStepEnum.extra_details]: () =>
    linkOptions({ to: "/company/extra-details" }),
}
